import React from "react"
import debounce from "lodash/debounce"
import classNames from "classnames"
import PostCard from "../PostCard/PostCard"
// import { get } from '../../utilities/get.js';
import { UserDataContext } from "../../context/UserDataContext"
import "./main.scss"
import { get } from "../../utilities/get"

const Main = () => {
  const [userData] = React.useContext(UserDataContext)
  //
  const [isMessageReveled, setMessageReveled] = React.useState(false)
  // TODO: Add logic reporting full scroll event
  // const [isBottomReached, setBottomReached] = React.useState(false)
  const message = React.useRef()

  // TODO: This works, if the ID is not dynamic. So maybe it need to be async with a loader in the future.
  // TODO: We should also abstract the first segment f the URL so it work locally and on the remote server with editing.
  /*  React.useEffect(() => {
    // get data from GitHub api
    // fetch(`https://api.github.com/repos/gatsbyjs/gatsby`)
    fetch(`http://christmas-2001.gd:8888/static/log/FirstName.php?u=${userData.id}`)
      .then(response => response.json()) // parse JSON from request
      .then(resultData => {
        // setStarsCount(resultData.stargazers_count)
        console.log(resultData)
      }) // set data for the number of stars
  }, []) */

  React.useLayoutEffect(() => {
    const calcMessageReveal = () => {
      const { pageYOffset } = window
      const pageInnerHeight = window.innerHeight
      const messageYOffset = message.current.getBoundingClientRect().top
      // console.log('window.pageYOffset: ' + window.pageYOffset)
      // console.log('window.innerHeight: ' + window.innerHeight)

      if (messageYOffset < pageYOffset + pageInnerHeight) {
        setMessageReveled(true)
      } else {
        setMessageReveled(false)
      }
    }

    const scrollEventDebouncer = debounce(() => {
      calcMessageReveal()
    }, 100)

    if (typeof window !== "undefined") {
      window.addEventListener("load", calcMessageReveal())
      window.addEventListener("scroll", scrollEventDebouncer)
      window.addEventListener("resize", scrollEventDebouncer)
    }
    // Remove listener (like componentWillUnmount)
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("load", calcMessageReveal())
        window.removeEventListener("scroll", scrollEventDebouncer)
        window.removeEventListener("resize", scrollEventDebouncer)
      }
    }
  }, [])

  const coraCookieClick = () => {
    get(`static/log/LogEvent.php?u=${userData.id}&e=cora cookie clicked`)
  }
  const lilyCookieClick = () => {
    get(`static/log/LogEvent.php?u=${userData.id}&e=lily cookie clicked`)
  }
  return (
    <main className="Main">
      <div className="Main-postCard">
        <div className="Main-postCardInner">
          <PostCard />
        </div>
      </div>
      <div className="Main-message">
        <div
          ref={message}
          className={classNames("Main-messageInner", {
            "is-visible": isMessageReveled === true,
          })}
        >
          <p>Hello friends! 👋</p>

          <p>You would think these cards would write themselves… and be on time, but we struggle every year to summarize the blur that was our last trip around the sun.</p>

            <p>We&apos;ve had a fun, (but increasingly sarcastic) year with the girls as Cora (12), and Lily (10) look and act more and more like teenagers every day.</p>

              <p>Cora&apos;s grades are amazing and she dazzles teachers with her effort and artistry. She plays volleyball 🏐
                year-round and would once again be happy to {" "}
                <a
                    href="https://digitalcookie.girlscouts.org/scout/cora941460"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => coraCookieClick()}
                >take your girl scout cookie order 🍪
                  {" "}</a>
                 (yes, we deliver nearby!).</p>

                <p>Lily also continues to shine as a student and hard-charging athlete. This year she&apos;s taken up violin in school, which she practices when she isn&apos;t busy playing soccer or basketball ⚽️🏀. We don&apos;t know where she get&apos;s the energy.</p>

                <p>Last spring Jenna stepped back from her role at Bose and has begun to take on design clients of her own this fall. In her free-time she continues to volunteer with Cora&apos;s Girls Scout troop and fit in a dance fusion class whenever possible.</p>

                <p>Meanwhile John went salary with long-term client, ZeroDegrees back in February. When he isn&apos;t working around the house he continues to coach sports having started a small youth volleyball program in town.</p>

                <p>Other than that… the tide gets shoveled daily. It&apos;s been a fun, challenging, rewarding year.  A perfect primer for 2025!</p>

                <p>Peace and love to all,</p>
                <p>- John, Jenna, Cora, Lily and Finn 🐾
                <br/>69 W Elm St, Hopkinton MA 01748</p>
        </div>
      </div>
    </main>
  )
}

export default Main
